import React from 'react';
import Copyright from './Copyright';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();


  const handleStatsClick = () => {
    window.location.href = '/stats';
  };

  const handlePerformanceClick = () => {
    window.location.href = '/benchmark';
  };

  return (
    <div className="bg-pl-bg border-t border-pl-border py-10 px-20">
      <div className="flex justify-end md:justify-between items-start text-14 text-pl-text-secondary font-light">
        {/* Left side container (visible on larger screens only) */}
        <div className="hidden md:flex flex-col gap-2">
          <div className="flex flex-row items-center gap-[30px]">
            <div
              className="flex-none h-[23px] leading-[22px] cursor-pointer"
              onClick={() => navigate("/search")}
            >
              Case law
            </div>
            <div
              className="flex-none h-[23px] leading-[22px] cursor-pointer"
              onClick={() => navigate("/reports")}
            >
              Law reports
            </div>
            <div
              className="flex-none h-[23px] leading-[22px] cursor-pointer"
              onClick={() => navigate("/legislations")}
            >
              Legislations
            </div>
            <div
              className="flex-none h-[23px] leading-[22px] cursor-pointer"
              onClick={() => navigate("/translate")}
            >
              Translate
            </div>
            <div
              className="flex-none h-[23px] leading-[22px] cursor-pointer"
              onClick={() => navigate("/dictionary")}
            >
              Dictionary
            </div>
          </div>
          <div className="flex flex-row items-center gap-[30px] text-pl-text-tertiary">
            <div
              className="flex-none h-[23px] leading-[22px] cursor-pointer"
              onClick={handlePerformanceClick}
            >
              Performance
            </div>
            <div
              className="flex-none h-[23px] leading-[22px] cursor-pointer"
              onClick={handleStatsClick}
            >
              Stats
            </div>
            <div
              className="flex-none h-[23px] leading-[22px] cursor-pointer"
              onClick={() => navigate("/help")}
            >
              Help
            </div>
            <div
              className="flex-none h-[23px] leading-[22px] cursor-pointer"
              onClick={() => navigate("/about")}
            >
              About
            </div>
          </div>
        </div>
        <div className="flex flex-col items-end gap-2">
          <div className="flex gap-10">
            <div
              className="flex-none h-[23px] leading-[22px] cursor-pointer"
              onClick={() => navigate("/careers")}
            >
              Careers
            </div>
            <div
              className="flex-none h-[23px] leading-[22px] cursor-pointer"
              onClick={() => navigate("/refund")}
            >
              Refund
            </div>
            <div
              className="flex-none h-[23px] leading-[22px] cursor-pointer"
              onClick={() => navigate("/privacy")}
            >
              Privacy
            </div>
            <div
              className="flex-none h-[23px] leading-[22px] cursor-pointer"
              onClick={() => navigate("/terms")}
            >
              Terms
            </div>
          </div>
          <Copyright />
        </div>
      </div>
    </div>
  );
};

export default Footer;
